import ReactMarkdown from 'react-markdown';

interface ChatMessageProps {
  role: 'user' | 'coach';
  content: string;
}

export function ChatMessage({ role, content }: ChatMessageProps) {
  const isUser = role === 'user';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        marginBottom: '12px',
      }}
    >
      <div
        style={{
          maxWidth: isUser ? '85%' : '100%',
          padding: '12px 16px',
          borderRadius: '14px',
          fontSize: '14px',
          lineHeight: 1.55,
          background: isUser ? 'var(--accent)' : 'var(--bg-card)',
          color: isUser ? '#0a1219' : 'var(--text-primary)',
          border: isUser ? 'none' : '1px solid var(--border)',
          whiteSpace: isUser ? 'pre-wrap' : undefined,
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          minWidth: 0,
        }}
      >
        {isUser ? (
          content
        ) : (
          <div className="coach-md">
            <ReactMarkdown>{content}</ReactMarkdown>
            <style>{`
              .coach-md > *:first-child { margin-top: 0; }
              .coach-md > *:last-child { margin-bottom: 0; }
              .coach-md p { margin: 0 0 8px 0; }
              .coach-md ul, .coach-md ol { margin: 0 0 8px 0; padding-left: 22px; }
              .coach-md li { margin-bottom: 4px; }
              .coach-md code {
                font-family: 'SF Mono', Menlo, monospace;
                font-size: 12.5px;
                background: rgba(0,212,255,0.08);
                padding: 1px 5px;
                border-radius: 4px;
              }
              .coach-md pre {
                background: rgba(0,0,0,0.25);
                padding: 10px 12px;
                border-radius: 8px;
                overflow-x: auto;
                margin: 0 0 8px 0;
              }
              .coach-md pre code { background: none; padding: 0; }
              .coach-md a { color: var(--accent); }
              .coach-md strong { color: var(--text-primary); }
            `}</style>
          </div>
        )}
      </div>
    </div>
  );
}
